import { encodeToByteArray1onwao0uakjfh as encodeToByteArray } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toByteArray1u8z8rctsleo7 as toByteArray } from './Float.ext.mjs';
import {
  _MonetaryValue___get_inUsCents__impl__icg2cu1ffzqvrb4rbpl as _MonetaryValue___get_inUsCents__impl__icg2cu,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
} from '../supportModels.mjs';
import { toByteArray1inlj2pk87rey as toByteArray_0 } from './Long.ext.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq,
  ServerFile1t91jzpzoixwe as ServerFile,
} from '../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringBefore3n7kj60w69hju as substringBefore } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toBitszo75lm27azgm as toBits } from '../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function hash(_this__u8e3s4, value) {
  return hash_0(_this__u8e3s4, value == null ? null : value.toString());
}
function hash_0(_this__u8e3s4, value) {
  var tmp1_safe_receiver = value == null ? null : encodeToByteArray(value);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.also' call
    _this__u8e3s4.e51(tmp1_safe_receiver);
    tmp = tmp1_safe_receiver;
  }
  var tmp2_elvis_lhs = tmp;
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    // Inline function 'kotlin.run' call
    _this__u8e3s4.c51(127);
    tmp_0 = Unit_instance;
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  return tmp_0;
}
function hash_1(_this__u8e3s4, value) {
  hash_0(_this__u8e3s4, value == null ? null : value.i20());
  hash_11(_this__u8e3s4, value == null ? null : value.i93());
  hash_0(_this__u8e3s4, value == null ? null : value.h93());
  hash_11(_this__u8e3s4, value == null ? null : value.j93());
}
function hash_2(_this__u8e3s4, value) {
  var tmp1_safe_receiver = value == null ? null : toByteArray(value);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.also' call
    _this__u8e3s4.e51(tmp1_safe_receiver);
    tmp = tmp1_safe_receiver;
  }
  var tmp2_elvis_lhs = tmp;
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    // Inline function 'kotlin.run' call
    _this__u8e3s4.c51(22);
    tmp_0 = Unit_instance;
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  return tmp_0;
}
function hash_3(_this__u8e3s4, value) {
  hash(_this__u8e3s4, value == null ? null : value.k54_1);
  hash_4(_this__u8e3s4, value == null ? null : value.o54_1);
}
function hash_4(_this__u8e3s4, value) {
  return hash_12(_this__u8e3s4, value == null ? null : value.r26());
}
function hash_5(_this__u8e3s4, value) {
  var tmp;
  var tmp_0 = value;
  if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
    tmp = null;
  } else {
    tmp = _MonetaryValue___get_inUsCents__impl__icg2cu(value);
  }
  var tmp1_safe_receiver = tmp;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toByteArray_0(tmp1_safe_receiver);
  var tmp_1;
  if (tmp2_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.also' call
    _this__u8e3s4.e51(tmp2_safe_receiver);
    tmp_1 = tmp2_safe_receiver;
  }
  var tmp3_elvis_lhs = tmp_1;
  var tmp_2;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.run' call
    _this__u8e3s4.c51(100);
    tmp_2 = Unit_instance;
  } else {
    tmp_2 = tmp3_elvis_lhs;
  }
  return tmp_2;
}
function hash_6(_this__u8e3s4, value) {
  hash(_this__u8e3s4, value.e6k_1);
  hash(_this__u8e3s4, value.f6k_1);
  hash_0(_this__u8e3s4, value.j6k_1);
  hash_0(_this__u8e3s4, value.k6k_1);
  hash_5(_this__u8e3s4, value.l6k_1);
  hash_13(_this__u8e3s4, value.m6k_1);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = value.n6k_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    hash_1(_this__u8e3s4, element);
  }
  hash_14(_this__u8e3s4, value.g6k_1);
  hash_4(_this__u8e3s4, value.o6k_1);
  hash_3(_this__u8e3s4, value.w6k_1);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = value.x6k_1.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    hash(_this__u8e3s4, element_0);
  }
  hash_4(_this__u8e3s4, value.y6k_1);
}
function hash_7(_this__u8e3s4, item) {
  hash(_this__u8e3s4, item.v6a_1);
  hash(_this__u8e3s4, item.w6a_1);
  hash(_this__u8e3s4, item.x6a_1);
  hash(_this__u8e3s4, item.y6a_1);
  hash_10(_this__u8e3s4, item.z6a_1);
  hash_0(_this__u8e3s4, item.a6b_1);
  hash_5(_this__u8e3s4, item.b6b_1);
  hash_10(_this__u8e3s4, item.c6b_1);
  hash_4(_this__u8e3s4, item.d6b_1);
  hash_0(_this__u8e3s4, item.e6b_1);
}
function hash_8(_this__u8e3s4, value) {
  hash(_this__u8e3s4, value.j7w_1);
  hash(_this__u8e3s4, value.k7w_1);
  hash(_this__u8e3s4, value.l7w_1);
  hash_0(_this__u8e3s4, value.o7w_1);
  hash_10(_this__u8e3s4, value.p7w_1);
  hash_3(_this__u8e3s4, value.q7w_1);
}
function hash_9(_this__u8e3s4, item) {
  hash(_this__u8e3s4, item.t75_1);
  hash(_this__u8e3s4, item.u75_1);
  hash(_this__u8e3s4, item.v75_1);
  hash_0(_this__u8e3s4, item.w75_1);
  hash_0(_this__u8e3s4, item.x75_1);
  hash_5(_this__u8e3s4, item.y75_1);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = item.z75_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    hash_1(_this__u8e3s4, element);
  }
}
function hash_10(_this__u8e3s4, value) {
  switch (value) {
    case true:
      _this__u8e3s4.c51(1);
      break;
    case false:
      _this__u8e3s4.c51(0);
      break;
    case null:
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function hash_11(_this__u8e3s4, value) {
  var tmp;
  var tmp_0 = value;
  if ((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null) {
    tmp = null;
  } else {
    tmp = _ServerFile___get_location__impl__ddyqaq(value);
  }
  var tmp1_safe_receiver = tmp;
  hash_0(_this__u8e3s4, tmp1_safe_receiver == null ? null : substringBefore(tmp1_safe_receiver, _Char___init__impl__6a9atx(63)));
}
function hash_12(_this__u8e3s4, value) {
  var tmp1_safe_receiver = value == null ? null : toByteArray_0(value);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.also' call
    _this__u8e3s4.e51(tmp1_safe_receiver);
    tmp = tmp1_safe_receiver;
  }
  var tmp2_elvis_lhs = tmp;
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    // Inline function 'kotlin.run' call
    _this__u8e3s4.c51(100);
    tmp_0 = Unit_instance;
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  return tmp_0;
}
function hash_13(_this__u8e3s4, value) {
  var tmp1_safe_receiver = value == null ? null : toBits(value);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toByteArray_0(tmp1_safe_receiver);
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.also' call
    _this__u8e3s4.e51(tmp2_safe_receiver);
    tmp = tmp2_safe_receiver;
  }
  var tmp3_elvis_lhs = tmp;
  var tmp_0;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.run' call
    _this__u8e3s4.c51(41);
    tmp_0 = Unit_instance;
  } else {
    tmp_0 = tmp3_elvis_lhs;
  }
  return tmp_0;
}
function hash_14(_this__u8e3s4, value) {
  var tmp;
  if (value == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.also' call
    hash(_this__u8e3s4, value.x5a_1);
    hash_0(_this__u8e3s4, value.y5a_1);
    tmp = value;
  }
  if (tmp == null) {
    // Inline function 'kotlin.run' call
    _this__u8e3s4.c51(-65);
  }
}
//region block: exports
export {
  hash_8 as hash1dirvvkne1yvs,
  hash_2 as hash2ytqmr282x9qt,
  hash_6 as hash2akpkpgdo278y,
  hash_3 as hash1eug6l3wjrtmb,
  hash_10 as hash1973x73wcw20i,
  hash_4 as hashdslf6mgodcq4,
  hash_7 as hash2ll8ltm3oky5s,
  hash_1 as hash2jpxxcb5iw7an,
  hash as hash1fp34sezu95cc,
  hash_0 as hash2teqor7x28bwm,
  hash_5 as hash1az8j7xdn0ud6,
  hash_9 as hash1raspm89m0xqg,
};
//endregion

//# sourceMappingURL=Bit32Digest.ext.mjs.map
